import { useLayoutEffect, FC, ReactNode } from "react";
import { useLocation } from 'react-router-dom'

interface PropType {
  children: any
}

const ScrollToTop: FC<PropType> = ({children}) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children
};

export default ScrollToTop;